//IMPORTANT: This file is only for experimental purposes. It is being used only on the login screen.

import { Dimensions, PixelRatio, Platform } from 'react-native';

const { width, height } = Dimensions.get('window');

//Scales
const scaleHorizontal = width / 375;
const scaleVertical = height / 812;

export function actuatedNormalizeHorizontal(size: number) {
  const newSize = size * scaleHorizontal;
  if (Platform.OS === 'ios') {
    return Math.round(PixelRatio.roundToNearestPixel(newSize));
  } else if (Platform.OS === 'android') {
    return Math.round(PixelRatio.roundToNearestPixel(newSize)) - 1;
  } else {
    return size;
  }
}

export function actuatedNormalizeVertical(size: number) {
  const newSize = size * scaleVertical;
  if (Platform.OS === 'ios') {
    return Math.round(PixelRatio.roundToNearestPixel(newSize));
  } else if (Platform.OS === 'android') {
    return Math.round(PixelRatio.roundToNearestPixel(newSize)) - 1;
  } else {
    return size;
  }
}
